import {useTranslation} from 'react-i18next';
import {Typography} from '@mui/material';
import {translations} from '../../../../../../../i18n/translations';
import {Modal, ModalProps} from '../../../../../../../components/modal/modal';
import FlatInput from '../../../../../../../components/flat-input/flat-input';
import {useState} from 'react';
import './pending-tasks-modal.scss';

interface PendingTasksModalProps extends Omit<ModalProps, 'actions'> {
  submitting: boolean;
  tasks: string[];
  onClose: () => void;
  onValidate: (observation: string) => void;
}

export const PendingTasksModal = ({
  submitting,
  tasks,
  onClose,
  onValidate,
}: PendingTasksModalProps) => {
  const {t} = useTranslation();
  const [observation, setObservation] = useState('');

  return (
    <Modal
      open
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      className="pending-tasks-modal"
      preventCloseClick
      actions={[
        {
          label: t(translations.office.generics.cancel),
          type: 'destructive',
          onClick: onClose,
          disabled: submitting,
        },
        {
          label: t(translations.office.pending_tasks.modal_validate),
          type: 'nondestructive',
          onClick: () => onValidate(observation),
          loading: submitting,
          disabled: submitting,
        },
      ]}
    >
      <>
        <Typography className="title">
          {t(translations.office.pending_tasks.modal_title, {
            number: tasks.length,
          })}
        </Typography>
        <FlatInput
          placeholder={t(translations.office.pending_tasks.modal_observation)}
          value={observation}
          rows={3}
          multiline
          onChange={(e) => setObservation(e.currentTarget.value)}
        />
      </>
    </Modal>
  );
};
